import { OrgAnalyticsResultItem, MyAnalytics, LabelType } from 'graphql/types';

const clientColorSet = ['#31383d', '#8832a1', '#d83559', '#563aa8', '#e54938'];
const projectColorSet = ['#308cea', '#fee653', '#364ba6', '#f1592e', '#2f887d'];
const taskColorSet = ['#cad44d', '#59717e', '#949494', '#309fec', '#f5912f'];
const activityColorSet = [
  '#2196f3',
  '#8bc34a',
  '#ec407a',
  '#ffb851',
  '#01579b'
];

export const labelColorset = (labelType: LabelType): string[] | undefined => {
  if (labelType === LabelType.Client || labelType === LabelType.Program)
    return clientColorSet;
  else if (labelType === LabelType.Project) return projectColorSet;
  else if (labelType === LabelType.Activity) return activityColorSet;
  else return taskColorSet;
};

export type PieChartData = {
  x: string;
  y: number;
  color: string;
  name: string;
  symbol: { fill: string };
}[];

export const transformLabelData = (
  data: MyAnalytics | undefined,
  labelType: LabelType
): PieChartData => {
  const colorSet = labelColorset(labelType) || [];
  const getChartColor = (index: number): string => {
    const colorSetLength = colorSet.length;
    if (index > colorSetLength - 1) {
      return colorSet[(index % colorSetLength) - 1];
    } else return colorSet[index];
  };

  const dataset = data?.dimensions.map((item, index) => {
    const value = {
      x: item.name,
      y: data.metrics[index].totalDuration,
      name: item.name
    };
    return value;
  });
  dataset?.sort((a, b) => a.name.localeCompare(b.name));
  const datasetWithColor = dataset?.map((data, i) => {
    const values = {
      x: data.x,
      y: data.y,
      color: getChartColor(i),
      name: data.name,
      symbol: { fill: getChartColor(i) }
    };
    return values;
  });
  return datasetWithColor || [];
};

export const transformLabelDataSupervisor = (
  data: (OrgAnalyticsResultItem | undefined | null)[] | undefined,
  labelType: LabelType
): PieChartData => {
  const colorSet = labelColorset(labelType) || [];
  const getChartColor = (index: number): string => {
    const colorSetLength = colorSet.length;
    if (index > colorSetLength - 1) {
      return colorSet[(index % colorSetLength) - 1];
    } else return colorSet[index];
  };
  const filterData = (data || []).filter((i) => {
    if (i !== null && i !== undefined) return i;
  }) as OrgAnalyticsResultItem[];
  const dataset = filterData.map((item) => {
    const value = {
      x: item.dimension.name,
      y: item.metrics.totalDuration,
      name: item.dimension.name
    };

    return value;
  });
  dataset.sort((a, b) => a.name.localeCompare(b.name));
  const datasetWithColor = dataset.map((data, i) => {
    const values = {
      x: data.x,
      y: data.y,
      color: getChartColor(i),
      name: data.name,
      symbol: { fill: getChartColor(i) }
    };
    return values;
  });
  return datasetWithColor || [];
};
